import { render, staticRenderFns } from "./StudentViewNotes.vue?vue&type=template&id=0d31d3d1&"
import script from "./StudentViewNotes.vue?vue&type=script&lang=js&"
export * from "./StudentViewNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports